<template>
    <div class="formulas-block-templates">
        <div
            class="formulas-block-templates-title"
        >
            <div> Select template:</div><div>
            <VButton v-if="allActive" type="button"
                                            theme="positive" style="width: 80px;"
                                            @click="deleteAllFormulas">Clear all</VButton>
            <VButton v-else type="button"
                                            theme="positive" style="width: 80px;"
                                            @click="addAllFormulas">Add all</VButton>
        </div>
        </div>
        <ul
            class="formulas-block-templates-dropdown"
        >
            <li
                v-for="(template,templateIndex) in templates"
                :key="`groupItem-${templateIndex}`"
                class="formulas-block-templates-dropdown-row"
            >
                <template v-if="formulasNames.includes(template.name)">
                        <span
                            class="formulas-block-templates-dropdown-row-icon formulas-block-templates-dropdown-row-icon_delete"
                            @click="deleteFormula(template)"
                        ></span>
                    <span
                        class="formulas-block-templates-dropdown-row__template formulas-block-templates-dropdown-row-name"
                    > {{ template.name }} </span>
                    <span
                        class="formulas-block-templates-dropdown-row__template formulas-block-templates-dropdown-row-desc">{{ template.equation }}</span>
                </template>
                <template v-else>
                    <span
                        class="formulas-block-templates-dropdown-row-icon formulas-block-templates-dropdown-row-icon_add "
                        @click="addFormula(template)"
                    ></span>
                    <span
                        class="formulas-block-templates-dropdown-row__template formulas-block-templates-dropdown-row-name formulas-block-templates-dropdown-row_inactive"
                    > {{ template.name
                        }} </span>
                    <span
                        class="formulas-block-templates-dropdown-row__template  formulas-block-templates-dropdown-row-desc formulas-block-templates-dropdown-row_inactive"
                    > {{ template.equation }} </span>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'formulas-block-templates',
        props: {
            templates: {
                type: Array,
                required: true,
            },
            formulas: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {

            };
        },
      computed: {
            formulasNames() {
                return this.formulas.map(({name}) => name);
            },
            allActive() {
                return this.templates.every(({name}) => this.formulasNames.includes(name));
            },
        },
        methods: {
            addFormula(template) {
                this.$emit('addFormula', template);
            },
            deleteFormula(template) {
                this.$emit('deleteFormula', template);
            },
            addAllFormulas() {
                const allFormulas = [];
                this.templates.forEach((formula) => {
                    if (!this.formulasNames.includes(formula.name)){
                        allFormulas.push(formula);
                    }
                })
                console.log('allFormulas1', _.cloneDeep(allFormulas));
                this.$emit('addAllFormulas', _.cloneDeep(allFormulas));
            },
            deleteAllFormulas() {
                this.templates.forEach((formula) => {
                    if (this.formulasNames.includes(formula.name)){
                        this.$emit('deleteFormula', _.cloneDeep(formula));
                    }
                })
            },
        },
    };
</script>


<style
    scoped
    lang="scss"
>
    .formulas-block-templates {
        position: relative;
        width: 100%;

        &-title{
            text-align: left;
            font-weight: bold;
            padding-top: 10px;
            padding-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &-dropdown {
            background: #FFFFFF;

            border-radius: 5px;
            border-bottom: 10px solid #FFFFFF;
            border-top: 10px solid #FFFFFF;

            &-item {
                border: 2px solid $primary-color;

                &_disabled {
                    filter: grayscale($disabled-grayscale);
                    border: 2px solid #FFFFFF;
                }
            }


            &-row {
                list-style-type: none;
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 5px;
                position: relative;
                text-align: left;
                &-name {
                    min-width: 100px;
                }
                &-desc {
                    width: 250px;
                }


                &_inactive {
                    opacity: .4;
                }

                &-icon {
                    width: 15px;
                    height: 15px;
                    cursor: pointer;

                    background-position: 0 0;
                    background-repeat: no-repeat;
                    background-size: contain;
                    margin-right: 5px;
                }

                &-icon_delete {
                    background-image: url('data:image/svg+xml;base64,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');
                }

                &-icon_add {
                    background-image: url('data:image/svg+xml;base64,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');
                }

                ::v-deep .VCheckbox {
                    margin: 0 10px;
                }
            }
        }
    }

</style>
